import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  GetPrefrencesBySpId,
  GetServiceProviderById,
} from "../../../utils/api";
import { message, Empty } from "antd";
import Loader from "../../shared/Loader";
import { commonDateFormat } from "../../../utils/helper";

const Prefrences = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [bakingdetails, setBakingdetails] = useState({});

  const getServiceById = async () => {
    setLoading(true);
    try {
      const res = await GetServiceProviderById(id);
      if (res?.isSuccess) {
        setUser(res?.data?.user);
        getBakingDetails(res?.data?.user_id);
      } else {
        message.error("Error while fetching details, Please try again");
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getBakingDetails = async (userId) => {
    try {
      const response = await GetPrefrencesBySpId(userId);
      if (response?.isSuccess) {
        setBakingdetails(response?.data);
        setLoading(false);
      } else {
        setLoading(false);
        message.error(response?.error);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getServiceById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="w-full flex flex-col gap-y-4 poppins p-6">
      <div className="flex gap-12 items-start">
        {bakingdetails?.accountDetails ? (
          <div class="flex flex-col gap-y-2 justify-center">
            <h1 className="text-[#2D2D37] font-bold leading-none">
              Bank Details
            </h1>
            <div className="flex gap-4 items-start">
              <div class="w-72 h-36 flex flex-col justify-between bg-gradient-to-r from-from-card via-via-card to-to-card rounded-2xl shadow-lg">
                <div class="flex justify-between m-2">
                  <span className="text-white font-xs poppins pt-2 pl-2">
                    {bakingdetails?.name}
                  </span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="34"
                    height="34"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="#ffffff"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <circle cx="9.5" cy="9.5" r="5.5" fill="#fff" />
                    <circle cx="14.5" cy="14.5" r="5.5" />
                  </svg>
                </div>
                <div class="flex justify-end pb-4 pr-4">
                  <h1 class="font-os text-white">
                    **** **** ****{" "}
                    {bakingdetails?.accountDetails[0]?.accountNumber}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <Empty description={<span>No banking details provided.</span>} />
          </div>
        )}
        <div class="flex flex-col gap-y-2 justify-center">
          <h1 className="text-[#2D2D37] font-bold leading-none">
            Subscription
          </h1>
          <div className="flex flex-col gap-1">
            <div className="flex gap-2 items-center">
              <h1 className="text-[#2D2D37] font-semibold leading-none">
                Current plan :
              </h1>
              <span className="text-[#2D2D37]">
                {user?.planName === "monthly_plan"
                  ? "Monthly"
                  : user?.planName === "annual_plan"
                  ? "Annually"
                  : ""}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <h1 className="text-[#2D2D37] font-semibold leading-none">
                Plan status :
              </h1>
              <span className="text-[#2D2D37] capitalize">
                {user?.planStatus}
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <h1 className="text-[#2D2D37] font-semibold leading-none">
                Expires on :
              </h1>
              <span className="text-[#2D2D37]">
                {commonDateFormat(user?.planExpiryDate)}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-y-2 justify-center">
        <h1 className="text-[#2D2D37] font-bold leading-none">
          Booking Policy
        </h1>
        <span className="text-[#444444] leading-tight text-xs">
          Cancellations must be made within {bakingdetails?.cancellationPeriod}
          hrs of your appointment date
          <br /> & {bakingdetails?.depositAmountType === "amount" && "£"}
          {bakingdetails?.depositAmount}.00
          {bakingdetails?.depositAmountType === "percentage" && "%"} deposit is
          required upon booking
        </span>
      </div>
    </div>
  );
};

export default Prefrences;
